<template>
  <CapNhatGroup />
</template>

<script>
import CapNhatGroup from "@/components/pages/quan-tri-he-thong/group/CapNhatGroup.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";
import {NAME_GROUP_TAB} from "../../../constants/constants";
export default {
  name: "TrangCapNhatGroup",
  components: {
    CapNhatGroup
  },
  data() {
    return {
      NAME_GROUP_TAB: NAME_GROUP_TAB,
      NAME: this.$route.params.id == 'tao-moi' ? MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.TAO : MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.SUA
    }
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME
      } / ${
        this.NAME
      }`
    );
  },
  watch: {
    $route: {
      handler() {
        setBreadcrumb(
            `${
                MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.SUA
            } / ${this.$route.params.items}`
        );
      },
    }
  }
};
</script>


